class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.predictiveSearchResultsMobile = document.querySelector('#predictive-search-mobile');  
    
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }
    
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.predictiveSearchResultsMobile.innerHTML = resultsMarkup;
        this.open();
        this.reset();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  
  reset() {
    const resetBtn = document.querySelectorAll('.reset_predictive_search');

    Array.from(resetBtn).forEach(btn => {
      btn.addEventListener('click', function(event) {
        document.querySelector('#predictive-search').classList.remove('active');
        document.querySelector('#predictive-search-mobile').classList.remove('active');
        document.querySelector('#desktop_search_box input[type="search"]').value = '';
        document.querySelector('#mobile_search_box input[type="search"]').value = '';
        return;
      });
    });
        
    
    
//     resetBtn.addEventListener("click", () => {
//       this.predictiveSearchResults.classList.remove('active');
//       this.input.value = '';
//       return;
//     });

  }
}

customElements.define('predictive-search', PredictiveSearch);
